import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import TextInput from 'components/Common/Form/Input/TextInput'

import InputText from 'LuxKit/Typography/InputText'
import { MAX_TRIP_NAME_CHARS } from 'tripPlanner/config'

const CharCount = styled(InputText)`
  position: absolute;
  bottom: -4px;
  transform: translateY(100%);
  right: 0px;
`

interface Props extends Utils.PropsWithDataAttributes {
  value: string
  onChange: (value: string) => void
  label?: string
  autoSelect?: boolean
  autoFocus?: boolean
  disabled?: boolean
}

function TripNameField({
  value,
  onChange,
  autoFocus,
  autoSelect,
  ...rest
}: Props) {
  const intl = useIntl()
  const inputRef = useRef<HTMLInputElement>(null)
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (inputRef.current) {
      if (autoSelect) {
        inputRef.current.select()
      } else if (autoFocus) {
        inputRef.current.focus()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TextInput
      {...rest}
      required
      ref={inputRef}
      onChange={(e) => {
        onChange(e.currentTarget.value)
        if (errorMsg) {
          setErrorMsg('')
        }
      }}
      manualError
      invalidErrorMessage={errorMsg}
      maxLength={MAX_TRIP_NAME_CHARS}
      value={value}
    >
      <CharCount variant="caption" colour="neutral-three">
        {intl.formatMessage(
          {
            id: 'VN74vUga7brBad_homem',
            defaultMessage: '{current}/{max}',
            description: 'Character count indicator for the trip name text input in the trip details editing form',
          },
          { current: value.length, max: MAX_TRIP_NAME_CHARS },
        )}
      </CharCount>
    </TextInput>
  )
}

export default TripNameField
